import { flattenContent, mapSection, staticSuperTable } from '~utils/mapping-filters'

const mapPage = (page) => {
  const masthead = staticSuperTable(page.masthead)
  const metadata = staticSuperTable(page.metadata)

  return {
    masthead: {
      ...flattenContent(masthead, 'subheading'),
      image: masthead.image[0]
    },
    sections: page.sections.map(mapSection),
    metadata
  }
}

export const mapCraft = (craft) => {
  return {
    ...craft,
    page: mapPage(craft.page)
  }
}